import { Components, Theme } from "@mui/material";
export const MuiMenu: Components<Omit<Theme, "components">>["MuiMenu"] = {
  styleOverrides: {
    list: {
      paddingTop: 0,
      paddingBottom: 0,
    },
  },
};
